import { A_B_TEST_NAME } from './enums';
import { HandleError, Region, UserId, UTMSource, CoreId, UserSource } from './Interfaces/DataProvider';

export class DataProvider {
  private gender: string;
  private growthBookTestName: string;
  private region: Region;
  private country: () => Promise<string | null>;
  private abTestName: string;
  private abTestSplitName: () => Promise<string | null>;
  private utmSource: UTMSource;
  private userId: UserId;
  private coreId: CoreId;
  private userEmail: string;
  private userSource: UserSource;
  public clientHandlerFn: (err: HandleError) => void;

  constructor() {
    this.gender = '';
    this.growthBookTestName = '';
    this.region = null;
    this.abTestName = A_B_TEST_NAME;
    this.abTestSplitName = async () => '';
    this.country = async () => '';
    this.utmSource = null;
    this.userSource = null;
    this.userId = null;
    this.coreId = null;
    this.clientHandlerFn = () => {};
    this.userEmail = '';
  }

  public handleError(err: HandleError): void {
    this.clientHandlerFn(err);
  }

  public async getAbTestName(): Promise<string | null> {
    return this.abTestName;
  }

  public async getAbTestSplitName(): Promise<string | null> {
    return this.abTestSplitName();
  }

  public async getCountry(): Promise<string | null> {
    return this.country();
  }

  public setUTMSource(utmSource: string): string {
    return (this.utmSource = utmSource);
  }

  public getUTMSource(): UTMSource {
    return this.utmSource;
  }

  public setUserSource(userSource: string): string {
    return (this.userSource = userSource);
  }

  public getUserSource(): UserSource {
    return this.userSource;
  }

  public setUserId(userId: number | string): Promise<void> {
    return new Promise((resolve) => {
      this.userId = userId;

      resolve();
    });
  }

  public setCoreId(coreId: number): Promise<void> {
    return new Promise((resolve) => {
      this.coreId = coreId;

      resolve();
    });
  }

  public setUserEmail(email: string) {
    this.userEmail = email;
  }

  public getUserId(): UserId {
    return this.userId;
  }

  public getCoreId(): CoreId {
    return this.coreId;
  }

  public getUserEmail(): string {
    return this.userEmail;
  }

  public getGrowthBookTestName(): string {
    return this.growthBookTestName;
  }

  public getRegion(): Region {
    return this.region;
  }

  public getGender() {
    const genderLS = localStorage.getItem('gender');

    if (!this.gender && genderLS) return genderLS;

    return this.gender;
  }

  async provideData(data: {
    gender?: string;
    country?: () => Promise<string | null>;
    abTestName?: string;
    abTestSplitName?: () => Promise<string | null>;
    clientHandlerFn?: (err: HandleError) => void;
    utmSource?: string;
    userSource?: string;
    userId?: number;
    coreId?: number;
    region?: Region;
    growthBookTestName?: string;
    userEmail?: string;
  }) {
    if (!data) return;

    if (data?.userId) {
      this.userId = data.userId;
    }

    if (data?.coreId) {
      this.coreId = data.coreId;
    }

    if (data?.gender) {
      this.gender = data.gender;
    }

    if (data?.userEmail) {
      this.userEmail = data.userEmail;
    }

    if (data?.growthBookTestName) {
      this.growthBookTestName = data.growthBookTestName;
    }

    if (data?.region) {
      this.region = data.region;
    }

    if (data?.utmSource) {
      this.utmSource = data.utmSource;
    }

    if (data?.userSource) {
      this.userSource = data.userSource;
    }

    if (data?.clientHandlerFn) {
      this.clientHandlerFn = data.clientHandlerFn;
    }

    if (data?.country) {
      this.country = data.country;
    }

    if (data?.abTestName) {
      this.abTestName = data.abTestName;
    }

    if (data?.abTestSplitName) {
      this.abTestSplitName = data.abTestSplitName;
    }
  }
}

export default new DataProvider();
